<template>
    <div class="details_body">
        <ul class="details_tab">
            <li @click="num = 0" :class="{active: num == 0}"><common-data name="appShortName_11"/>介绍</li>
            <li @click="num = 1" :class="{active: num == 1}">功能介绍</li>
            <li @click="num = 2" :class="{active: num == 2}">购买须知</li>
            <!-- <li @click="num = 3" :class="{active: num == 3}">服务介绍</li> -->
        </ul>
        <div class="details_gn" v-show="num == 0">
            <p class="intent">文华财经旗下的一款量化交易软件。资金管理层面的专业视角，积木式编程语言、期货化的回测工具、列表式运行管理界面，支持投资组合配置、运行收益分析、单元头寸管理、风险控制...</p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 1">
            <p class='detail_title'>8C基础功能包（页面盒子+模组）</p>
            <p>1.包含8E功能；</p>
            <p>2.模组后台全自动运行，支持运行单元资金/持仓管理、产品申购赎回管理、自动移仓换月、策略优化运行、运行分析报告、分区总资金曲线、远程服务器监控及日志邮件发送通知。</p>
            <!-- <p class='tent'>* 仅限使用WT8软件登录；</p> -->
            <p class='tent'>* 本服务中必须提供的数据及信息仅限用户另外付费选配的范围；服务期内我司有权对其他数据及信息进行增、减等调整。</p>
            <p><a href='https://wt8.wenhua.com.cn/#/buy' target='_blank'>>>> 查看8C基础功能包 (盒子+模组)更多功能</a></p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 2">
            <p class="tent">1.付费成功后如无功能问题或未报备使用程序化交易软件，恕不退不换。</p>
            <p class='tent'>2.购买前请先下载<a href='https://wt8.wenhua.com.cn' target='_blank'><common-data name="appShortName_11"/></a>体验版了解软件基础功能。</p>
            <p class='tent'>
                3.使用<common-data name="appShortName_11"/>软件的电脑配置要求：<br />
                · CPU：X86架构，4核及以上配置；<br />
                · 内存：要达到8G及以上；<br />
                · 操作系统：win10/win11/win_server2016，64位版本；
            </p>
            <p class='tent'>4.推荐南方地区使用电信网络，北方地区使用联通网络，其它网络使用效果不佳。</p>
            <p class='tent'>5.使用授权账号登录后可选择文华支持的任意期货公司进行交易（<a href='https://wt8.wenhua.com.cn/#/trade' target='_blank'>查看文华支持的期货公司名单</a>），但如以后因所开户的期货公司交易通道关闭，文华不负责解决并不退还剩余费用。</p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 3"></div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                num: 2
            }
        },
    }
</script>
<style scope>
@import url('./doc.css');
    .details_gn{
        min-height: 255px;
    }
</style>